<template>
	<div class="container">
		<div class="content">
			<div class="card">
				<h3 class="title mb_20">{{ $t('rtr_pay-exchange.title1') }}</h3>

				<ul id="buySell" class="tab_area mb_10">
					<li
						:class="[{ selected: selectedTab === 'BID' }, 'buy']"
						@click="selectedTab = 'BID'"
					>
						<a>{{ $t('rtr_pay-exchange.tab1') }}</a>
					</li>
					<li
						:class="[{ selected: selectedTab === 'ASK' }, 'sell']"
						@click="selectedTab = 'ASK'"
					>
						<a>{{ $t('rtr_pay-exchange.tab2') }}</a>
					</li>
				</ul>

				<div class="exchange_wrap">
					<div class="mb_10">
						<div class="">
							<div class="source_box">
								<CustomSelectBox
									ref="sourceSelect"
									:placeholder="sourcePlaceholder"
									:options="sourceAssets"
									:show-account="true"
									@selectItem="selectSourceAsset"
								></CustomSelectBox>
							</div>
							<div class="space_arrow">
								<img src="@/assets/images/icon/equals.png" alt="equals image" />
							</div>
							<div class="target_box mb_10">
								<CustomSelectBox
									ref="targetSelect"
									:placeholder="targetPlaceholder"
									:disable="targetDisable"
									:options="targetAssets"
									:show-account="true"
									@selectItem="selectTargetAsset"
								></CustomSelectBox>
							</div>
						</div>
						<div class="">
							<div class="">
								<p class="mb_10" v-if="selectedTab === 'BID'">
									{{ $t('rtr_pay-exchange.text2') }}
								</p>
								<p class="mb_10" v-else>{{ $t('rtr_pay-exchange.text8') }}</p>
								<input
									type="text"
									v-model="sourceAmount"
									class="tar mb_10"
									placeholder="0"
									:disabled="amountDisable"
								/>
							</div>
							<div class="mb_40">
								<p class="mb_10">{{ $t('rtr_pay-exchange.text3') }}</p>
								<input
									type="text"
									v-model="targetAmount"
									class="tar"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="bg_black_box mb_40">
						<div v-if="selectedTab === 'BID'">
							<span>{{ $t('rtr_pay-exchange.text4') }}</span>
							<p>
								{{ !selectedMarket ? 0 : selectedMarket.bid_spread_rate }} %
							</p>
						</div>
						<div v-else>
							<span>{{ $t('rtr_pay-exchange.text5') }}</span>
							<p>
								{{ !selectedMarket ? 0 : selectedMarket.ask_spread_rate }} %
							</p>
						</div>
						<div>
							<span>{{ $t('rtr_pay-exchange.text6') }}</span>
							<p>
								{{
									!selectedMarket
										? 0
										: '1 ' +
										  selectedMarket.source_asset_code +
										  ' = ' +
										  selectedMarket.basic_rate +
										  ' ' +
										  selectedMarket.target_asset_code
								}}
							</p>
						</div>
						<div>
							<span>{{ $t('rtr_pay-exchange.text7') }}</span>
							<p>{{ exchangeRate }}</p>
						</div>
						<span class="divide_line mt_0"></span>
						<div class="text">
							<span v-if="selectedTab === 'BID'">{{
								$t('rtr_pay-exchange.text2')
							}}</span>
							<span v-else>{{ $t('rtr_pay-exchange.text8') }}</span>
							<p>{{ !sourceAmount ? 0 : sourceAmount }}</p>
						</div>
						<div class="text mb_0">
							<span>{{ $t('rtr_pay-exchange.text3') }}</span>
							<p class="fw_bold">{{ targetAmount }}</p>
						</div>
					</div>
					<button
						class="button_bg_red button_m"
						:disabled="!canExchange"
						@click="onDirectTransferHandler"
					>
						{{ $t('rtr_pay-exchange.title1') }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<ModalViewM
		v-if="accountRegistModal"
		@closeModal="accountRegistModal = false"
	>
		<template #title>
			<h3 class="modal_title_m tal">
				{{ $t('rtr_wallet_account-assets.title3') }}
			</h3>
		</template>
		<AccountRegister
			@closeRegist="closeRegist"
			:asset-info="selectedAsset"
		></AccountRegister>
	</ModalViewM>
	<ModalMessageM v-if="messageModal" @closeModal="closeMessageModal">
		<div :class="'status_icon ' + modalIcon"></div>
		<p v-if="messageModalMode === 'information'" class="mb_40">
			<span class="fw_bold fc_red">{{ $t('rtr_pay-exchange.title1') }}</span>
			{{ $t('rtr_pay-exchange.text9') }}
		</p>
		<p v-else class="status_text mb_40">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'">
			<!--      환전 정상 처리 되었을때 나오는 버튼-->
			<button class="button_bg_red button_m" @click="toActivity">
				{{ $t('button.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'warning'">
			<!--      자산 없을때 나오는 버튼 -->
			<button
				class="button_bg_red button_m"
				@click="(messageModal = false), (accountRegistModal = true)"
			>
				{{ $t('button.new_account') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'">
			<button class="button_bg_red button_m" @click="directTransfer">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessageM>
	<Tutorial v-if="showTutorial" @close="showTutorial = false"></Tutorial>
</template>

<script>
import CustomSelectBox from '@/components/CustomSelectBox';
import ModalViewM from '@/components/Layout/ModalView.m';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import { mapGetters } from 'vuex';
import { createDirectTransfer, fetchDirectMarkets } from '@/api/market';
import { commonError } from '@/common/dialog';
import { uniqBy } from 'lodash';
import AccountRegister from '@/components/AccountRegister';
import Tutorial from '@/components/Tutorial';
import Cookies from 'js-cookie';

export default {
	name: 'Exchange.m',
	components: {
		CustomSelectBox,
		ModalViewM,
		ModalMessageM,
		AccountRegister,
		Tutorial,
	},
	data() {
		return {
			selectedTab: 'BID',
			markets: [],
			selectedSourceSeq: '',
			selectedTargetSeq: '',
			sourceAmount: null,
			accountRegistModal: false,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			newAssetSeq: '',
			selectedAssetSeq: null,
			target: '',
			tour: null,
			showTutorial: false,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('assets', ['assets']),
		sourceAssets() {
			let result = [];
			const key = this.selectedTab === 'BID' ? 'allow_bid' : 'allow_ask';
			this.markets.forEach(market => {
				const sourceAsset = this.assets.find(asset => {
					return asset.seq === market.source_asset_seq;
				});
				const targetAsset = this.assets.find(asset => {
					return asset.seq === market.target_asset_seq;
				});
				if (sourceAsset && targetAsset && market[key] === 'Y')
					result.push(sourceAsset);
			});
			return uniqBy(result, 'seq');
		},
		targetAssets() {
			let result = [];
			const key = this.selectedTab === 'BID' ? 'allow_bid' : 'allow_ask';
			this.markets.forEach(market => {
				const asset = this.assets.find(asset => {
					return (
						market.source_asset_seq === this.selectedSourceSeq &&
						asset.seq === market.target_asset_seq &&
						market[key] === 'Y'
					);
				});
				if (asset) result.push(asset);
			});
			return uniqBy(result, 'seq');
		},
		selectedSourceAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.selectedSourceSeq;
			});
		},
		selectedTargetAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.selectedTargetSeq;
			});
		},
		selectedMarket() {
			return this.markets.find(item => {
				return (
					item.source_asset_seq === this.selectedSourceSeq &&
					item.target_asset_seq === this.selectedTargetSeq
				);
			});
		},
		exchangeRate() {
			if (!this.selectedMarket) return 0;
			else return this.calcExchangeRate();
		},
		targetAmount() {
			if (!this.selectedTargetSeq) return 0;
			const decimalPoint = parseInt(
				this.assets.find(item => {
					return item.seq === this.selectedTargetSeq;
				}).decimal_point,
			);
			return (this.sourceAmount * this.exchangeRate).toFixed(decimalPoint);
		},
		canExchange() {
			if (this.selectedMarket && this.sourceAmount) return true;
			else return false;
		},
		selectedAsset() {
			return this.assets.find(item => {
				return item.seq === this.selectedAssetSeq;
			});
		},
		sourcePlaceholder() {
			return this.selectedTab === 'BID'
				? this.$t('rtr_pay-exchange.text10')
				: this.$t('rtr_pay-exchange.text12');
		},
		targetPlaceholder() {
			return this.selectedTab === 'BID'
				? this.$t('rtr_pay-exchange.text11')
				: this.$t('rtr_pay-exchange.text13');
		},
		targetDisable() {
			return !this.selectedSourceAccount;
		},
		amountDisable() {
			return !(this.selectedSourceAccount && this.selectedTargetAccount);
		},
	},
	watch: {
		selectedSourceSeq() {
			this.selectedTargetSeq = '';
			this.$refs.targetSelect.initSelected();
		},
		selectedTab() {
			this.initForm();
		},
		sourceAmount(value) {
			if (!value) return;
			this.sourceAmount = value
				.replace(/[^0-9.]/g, '')
				.replace(/(\..*)\./g, '$1');
		},
	},
	created() {
		this.init();
	},
	methods: {
		closeMessageModal() {
			if (this.messageModalMode === 'success') {
				this.initForm();
				window.scrollTo(0, 0);
			} else {
				this.messageModal = false;
			}
		},
		init() {
			this.loadMarkets();
		},
		async loadMarkets() {
			const { data } = await fetchDirectMarkets().catch(commonError);
			this.markets = data.filter(item => {
				return item.is_active === 'Y';
			});
		},
		checkAccount(target) {
			console.log(target);
			const assetSeq =
				target === 'source' ? this.selectedSourceSeq : this.selectedTargetSeq;
			const account = this.accounts.find(item => {
				return item.asset_seq === assetSeq;
			});
			if (!account) {
				this.selectedAssetSeq = assetSeq;
				this.target = target;
				if (target === 'source') {
					this.newAssetSeq = this.selectedSourceSeq;
					this.selectedSourceSeq = '';
					this.$refs.sourceSelect.initSelected();
				} else {
					this.newAssetSeq = this.selectedTargetSeq;
					this.selectedTargetSeq = '';
					this.$refs.targetSelect.initSelected();
				}
				this.modalStatusMessage = this.$t('modal.message.no_account');
				this.modalIcon = 'warning';
				this.messageModalMode = 'warning';
				this.messageModal = true;
			}
		},
		selectSourceAsset(assetSeq) {
			this.selectedSourceSeq = assetSeq;
			this.checkAccount('source');
		},
		selectTargetAsset(assetSeq) {
			this.selectedTargetSeq = assetSeq;
			this.checkAccount('target');
		},
		calcExchangeRate() {
			const decimalPoint = parseInt(
				this.assets.find(item => {
					return item.seq === this.selectedTargetSeq;
				}).decimal_point,
			);
			const basicRate = parseFloat(this.selectedMarket.basic_rate).toFixed(
				decimalPoint,
			);
			switch (this.selectedTab) {
				case 'BID':
					return (
						basicRate *
						(this.selectedMarket.bid_spread_rate / 100 + 1)
					).toFixed(decimalPoint);
				case 'ASK':
					return (
						basicRate *
						(this.selectedMarket.ask_spread_rate / -100 + 1)
					).toFixed(decimalPoint);
				default:
					break;
			}
			return 0;
		},
		onDirectTransferHandler() {
			this.modalIcon = 'information';
			this.messageModalMode = 'information';
			this.messageModal = true;
		},
		directTransfer() {
			this.messageModal = false;
			const data = {
				market_seq: this.selectedMarket.seq,
				source_account_seq: this.selectedSourceAccount.seq,
				target_account_seq: this.selectedTargetAccount.seq,
				transfer_type: this.selectedTab,
				source_amount: this.sourceAmount,
			};
			createDirectTransfer(data)
				.then(() => {
					this.$store.dispatch('account/getAccounts');
					this.modalStatusMessage = this.$t('modal.message.success_exchange');
					this.modalIcon = 'success';
					this.messageModalMode = 'success';
					this.messageModal = true;
				})
				.catch(commonError);
		},
		closeRegist(seq) {
			if (seq) {
				const accountInfo = this.accounts.find(item => {
					return item.seq === seq;
				});
				this.target === 'source'
					? this.$refs.sourceSelect.selectItem(accountInfo.asset_seq)
					: this.$refs.targetSelect.selectItem(accountInfo.asset_seq);
			}
			this.accountRegistModal = false;
		},
		initForm() {
			this.messageModal = false;
			this.selectedSourceSeq = '';
			this.selectedTargetSeq = '';
			this.sourceAmount = null;
			this.$refs.sourceSelect.initSelected();
			this.$refs.targetSelect.initSelected();
		},
		toActivity() {
			this.$router.push({
				name: 'activity-exchange',
			});
		},
		tutorialHandler() {
			if (!Cookies.get(this.$route.name + '_tutorial')) {
				this.showTutorial = true;
			}
		},
	},
	mounted() {
		this.tutorialHandler();
	},
};
</script>
<style scoped></style>
